export default "__VITE_ASSET__Cz0$iZ2V__"